import { SelectBox } from 'components/Select/Select';
import React, { useEffect, useState } from 'react'
import { getDataAsync } from '../../api';
import { InputLoad } from 'components/InputLoading/inputLoading';

function ApiRequestConfigurator({name,label,required,mode,defaultValue,baseUrl,endpoint,onChange}) {
    const [data,setdData]=useState<any>()
  const [dataLoading,setdDataLoading]=useState<any>(false)


  const getControllerLookupConfigDataAsync=async()=>{
  setdDataLoading(false)
  try{
  const res=await getDataAsync(baseUrl,endpoint)
setdData(res)

if(!defaultValue){

    onChange(res[0]?.Id,res[0])
}

 
  }catch{}

  setdDataLoading(true)
  
}





    useEffect(()=>{
        getControllerLookupConfigDataAsync()
    },[])
  return (
    <div>
    {dataLoading?  <SelectBox
                onChange={(e) => {
                  onChange(e.target.value,data.find( item=>item.Id==e.target.value))
                  
                }}
                required={required}
                mode={mode}
                lable={label}
                selectType="select"
                value={defaultValue?defaultValue:data?.map(item=>item.Id)[0]}
                options={data?.map(item=>item.Description)}
                val={data?.map(item=>item.Id)}
                name={name}
              />
            :
            <InputLoad
            onClick={getControllerLookupConfigDataAsync}
            labelText={label}
            />
            
            }


    </div>
  )
}

export default ApiRequestConfigurator